module.exports = "/assets/6f6fc516bb59af755329e60189c675eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RE.png
// module id = 2906
// module chunks = 0